export default {"src":"/_next/static/media/icon-mission-critical-speed.c847990a.svg","height":44,"width":45,"blurWidth":0,"blurHeight":0};